import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { setReasonRefusal } from '../../store/ducks/reasonRefusal/action';

export default function useGetReasonRefusal() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(reasonRefusalId: string) {
    try {
      setLoading(true);
      const response = await api.get(
        `v1/backoffice/reasons-refusal/${reasonRefusalId} `,
      );

      if (response.status === 200) {
        dispatch(
          setReasonRefusal({
            description: response.data.description,
            reason: response.data.reason,
          }),
        );
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
